import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros } from "@/utils/numberUtils";
import { ConsumableDto } from "@/core/features/consumables/consumable.dto";
import { PurchaseOrderDto } from "@/core/features/purchase-orders/purchase-order.dto";
import { ItemModelDto } from "@/core/features/item-models/item-model.dto";
import { DeliveryNoteLineDto } from "@/core/features/delivery-notes/delivery-note-line.dto";
import { ServiceDto } from "@/core/features/services/service.dto";

export class PurchaseOrderLineDto extends BaseEntityDto {
  @Type(() => PurchaseOrderDto)
  purchaseOrder: PurchaseOrderDto;
  purchaseOrderId: string;

  @Type(() => ItemModelDto)
  itemModel?: ItemModelDto;
  itemModelId?: string;

  @Type(() => ConsumableDto)
  consumable?: ConsumableDto;
  consumableId?: string;

  @Type(() => ServiceDto)
  service?: ServiceDto;
  serviceId?: string;

  quantity: number;

  quantityToReceive: number;

  @Transform(({ value }) => toEuros(value))
  unitPrice: number;

  externalReference?: string;

  notes?: string;

  @Type(() => DeliveryNoteLineDto)
  deliveryNoteLines?: DeliveryNoteLineDto[];

  toString() {
    const ref = this.itemModel?.toString() ?? this.consumable?.toString() ?? this.service?.toString() ?? "???";
    return `${ref} ×${this.quantity}`;
  }
}
